<div class="container-fluid containerFailed">
    <h4 class="text-muted text-center"><br> {{ 'FAILED.LABEL1' | translate }} </h4>
    <div class ="mb-3">
        <mat-card class="failedCard">
            <mat-card-content>
                <div class="container-fluid p-1">
                    <div>
                        <img class="w-100" id="failed">
                    </div>
                    <div>
                        <p class="text-center textTitle"><br> {{ 'FAILED.LABEL2' | translate }} </p>
                        <p class="align-items-stretch textSubtitle"> {{ 'FAILED.LABEL3' | translate }} 
                        </p>
                        <p class=" align-items-stretch textSubtitleMuted muted-color"> {{ 'FAILED.LABEL4' | translate }} </p>
                        <p class="align-items-stretch textSubtitleBlack muted-color-2 mt-5"> {{ 'FAILED.LABEL5' | translate }} </p>
                        <p class="align-items-stretch textSubtitleBlackStrong black-color "> {{ 'FAILED.LABEL6' | translate }} </p>
                        <p class="align-items-stretch textSubtitleMuted muted-color mb-5"> {{ 'FAILED.LABEL7' | translate }} </p>
                    </div>
                        <div class="row px-md-5">
                            <div class="col d-flex justify-content-center">
                                <img id="Robo_ico" class="imageFailed" />
                            </div>
                            <div class="col d-flex justify-content-center">
                                <img id="Rotura_pantallas_Ico" class="imageFailed" />
                            </div>
                            <div class="col d-flex justify-content-center">
                                <img id="Mojaduras_ico" class="imageFailed" />
                            </div>
                            <div class="col d-flex justify-content-center">
                                <img id="Caidas_ico" class="imageFailed" />
                            </div>
                        </div>
                    <div class="row mt-2 px-md-5">
                        <div class="col d-flex justify-content-center">
                            <span class="textCarac black-color"> {{ 'FAILED.LABEL8' | translate }} </span>
                        </div>
                        <div class="col d-flex justify-content-center">
                            <span class="textCarac black-color"> {{ 'FAILED.LABEL9' | translate }} </span>
                        </div>
                        <div class="col d-flex justify-content-center">
                            <span class="textCarac black-color"> {{ 'FAILED.LABEL10' | translate }} </span>
                        </div>
                        <div class="col d-flex justify-content-center">
                            <span class="textCarac black-color"> {{ 'FAILED.LABEL11' | translate }} </span>
                        </div>
                    </div>
                    <br><br>
                    <div class="col-sm-12 col-md-12 ">
                        <div class="row">
                            <div class="col-3 col-lg-4"></div>
                            <div class="col-sm-12 col-md-6 col-lg-4">
                                <a href="../../../assets/themes/liverpool/files/Garantia_PIF.pdf" download="Garantia_PIF">
                                    <button class="p-2 mt-3 buttonCustom w-100 primary-color" type="button" mat-stroked-button>
                                        <span style="margin-right: 15px;"><fa-icon [icon]="faDownload" class="fa-solid fa-download primary-color "></fa-icon></span> <span class="primary-color"> {{ 'FAILED.LABEL12' | translate }} </span>
                                    </button>
                                </a>
                            </div>
                            <div class="col-3 col-lg-4"></div>
                        </div>
                    </div>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
    <div class="row">
        <div class="d-sm-none d-md-block col-6 col-md-6 col-lg-9"></div>
        <div class="col-6 col-md-6 col-lg-3 d-none d-sm-none d-md-flex justify-content-end mt-4">
            <button class="w-100 p-1" type="button" (click)="stepOn()" mat-raised-button color="accent"> {{ 'FAILED.LABEL13' | translate }} </button>
        </div>
        <div class="d-block d-sm-block d-md-none w-100">
            <mat-card class="serviceCard my-3">
                <mat-card-content>
                    <button class="w-100 p-1" type="button" (click)="stepOn()" mat-raised-button color="accent"> {{ 'FAILED.LABEL13' | translate }} </button>
                </mat-card-content>
            </mat-card>
        </div>
    </div><br><br>
</div>